export const getMendozaData = () => ({
  name: "Mendoza",
  country: "Argentine",
  description: "Mendoza est le cœur viticole de l'Argentine, produisant 70% des vins du pays. Cette région bénéficie d'un climat continental unique avec des vignobles en altitude dans les Andes, créant des conditions idéales pour la production de vins de qualité exceptionnelle.",
  type: "region",
  subregions: {
    "lujan-de-cuyo": {
      name: "Luján de Cuyo",
      description: "Cœur historique de Mendoza, réputé pour ses Malbec emblématiques et ses vins de qualité exceptionnelle.",
      characteristics: {
        climate: "Continental avec influences andines",
        soil: "Sols alluviaux et calcaires",
        viticulture: "Vignobles en altitude, irrigation contrôlée"
      },
      grapeVarieties: {
        red: ["Malbec", "Cabernet Sauvignon", "Syrah"],
        white: ["Chardonnay", "Torrontés", "Sauvignon Blanc"]
      },
      wineStyles: {
        "malbec": "Malbec puissants et fruités",
        "cabernet-sauvignon": "Cabernet Sauvignon structurés",
        "chardonnay": "Chardonnay aromatiques et complexes"
      },
      foodPairing: "Asado, viandes rouges, fromages affinés, cuisine argentine"
    },
    "maipu": {
      name: "Maipú",
      description: "Région traditionnelle produisant des vins de qualité avec une forte identité locale.",
      characteristics: {
        climate: "Continental, étés chauds",
        soil: "Sols alluviaux et sableux",
        viticulture: "Viticulture traditionnelle, irrigation contrôlée"
      },
      grapeVarieties: {
        red: ["Malbec", "Cabernet Sauvignon", "Bonarda"],
        white: ["Chardonnay", "Torrontés", "Sauvignon Blanc"]
      },
      wineStyles: {
        "malbec": "Malbec équilibrés et fruités",
        "cabernet-sauvignon": "Cabernet Sauvignon structurés",
        "chardonnay": "Chardonnay frais et aromatiques"
      },
      foodPairing: "Viandes rouges, empanadas, cuisine traditionnelle"
    },
    "valle-de-uco": {
      name: "Valle de Uco",
      description: "Région d'altitude réputée pour ses vins d'exception et ses vignobles en altitude.",
      characteristics: {
        climate: "Continental, altitude élevée",
        soil: "Sols calcaires et granitiques",
        viticulture: "Vignobles en altitude, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Malbec", "Cabernet Sauvignon", "Pinot Noir"],
        white: ["Chardonnay", "Sauvignon Blanc", "Semillon"]
      },
      wineStyles: {
        "malbec": "Malbec élégants et complexes",
        "pinot-noir": "Pinot Noir frais et aromatiques",
        "chardonnay": "Chardonnay complexes et minéraux"
      },
      foodPairing: "Viandes rouges, poissons, cuisine gastronomique"
    },
    "san-rafael": {
      name: "San Rafael",
      description: "Région méridionale produisant des vins traditionnels avec une forte identité locale.",
      characteristics: {
        climate: "Continental, influence océanique",
        soil: "Sols alluviaux et argileux",
        viticulture: "Viticulture traditionnelle, irrigation contrôlée"
      },
      grapeVarieties: {
        red: ["Malbec", "Cabernet Sauvignon", "Syrah"],
        white: ["Chardonnay", "Torrontés", "Chenin Blanc"]
      },
      wineStyles: {
        "malbec": "Malbec fruités et accessibles",
        "cabernet-sauvignon": "Cabernet Sauvignon équilibrés",
        "chardonnay": "Chardonnay frais et fruités"
      },
      foodPairing: "Viandes rouges, volailles, cuisine locale"
    }
  },
  mapAreas: [
    { region: "Luján de Cuyo", x: 35, y: 60, color: "#4B164C", size: 6 },
    { region: "Maipú", x: 38, y: 58, color: "#6d2c7a", size: 5 },
    { region: "Valle de Uco", x: 32, y: 65, color: "#8a4a8a", size: 5 },
    { region: "San Rafael", x: 25, y: 70, color: "#a768a6", size: 4 }
  ],
  statistics: {
    totalArea: "150,000 ha",
    production: "8.4 million hectolitres",
    subregions: "4 sous-régions principales",
    appellations: "15+ appellations",
    altitude: "600-1500m"
  },
  characteristics: {
    climate: "Climat continental avec influences andines, étés chauds et secs, hivers froids",
    soil: "Sols alluviaux, calcaires, sableux, excellente drainage",
    viticulture: "Vignobles en altitude, irrigation contrôlée, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges puissants et fruités, Malbec emblématique avec des tanins mûrs",
    white: "Vins blancs frais et aromatiques, Chardonnay et Torrontés",
    rose: "Rosés fruités et accessibles, parfaits pour l'apéritif",
    sparkling: "Vins effervescents de méthode traditionnelle"
  },
  history: "La viticulture à Mendoza remonte à l'arrivée des conquistadors espagnols au XVIe siècle. Les missionnaires jésuites ont développé les premiers vignobles. L'immigration italienne au XIXe siècle a apporté de nouvelles techniques et cépages. Le Malbec, originaire de France, est devenu le cépage emblématique de Mendoza. Aujourd'hui, Mendoza est reconnue mondialement pour la qualité de ses vins.",
  foodPairing: "Cuisine argentine traditionnelle : asado (barbecue), empanadas, locro, dulce de leche. Les vins de Mendoza s'accordent parfaitement avec les viandes rouges, les fromages affinés et la gastronomie internationale."
}); 